function Footer() {
    return <div className="footer">
        <p className="text-grey text-center">&copy; copyrights cosecure 2021</p>
    </div>
}

export default Footer;